<app-modal [info]="info" (closeModal)="closeModal($event)"></app-modal>
